<template>
    <div class="agentToolbarParent" v-show="!isOnlyCrm">
        <!-- <h1>Agent Toolbar</h1> -->
			<!-- v-bind:class="{ 'displayNone': buttonsCount == 0 }" -->
        <div v-show="!displayButtons" class="buttons">
            <div class="rowb row1">
                <a class="roundBtn " v-if="status.loginStatus == 0" ng-if="!$root.isVirtual" @click="!doing.login && changeAgentStatus('login')" v-b-tooltip :title="$t('login_title')">
                    <span class="fa-stack fa-1x">
                    <i class="fa fa-circle fa-stack-2x loginBG"></i>
                    <i v-if="!doing.login" class="fa fa-sign-in fa-stack-1x fa-inverse"></i>
                    <i v-if="doing.login" class="fas fa-spinner fa-spin fa-stack-1x fa-inverse"></i>
                    </span></a>

                <a class="roundBtn " v-if="status.loginStatus != 0" ng-if="!$root.isVirtual" @click="!doing.logoff && changeAgentStatus('logoff')" v-b-tooltip="" :title="$t('logout_title')">
                    <span class="fa-stack fa-1x">
                    <i class="fa fa-circle fa-stack-2x logoutBG"></i>
                    <i v-if="!doing.logoff" class="fa fa-power-off fa-stack-1x fa-inverse"></i>
                    <i v-if="doing.logoff" class="fas fa-spinner fa-spin fa-stack-1x fa-inverse"></i>
                    </span>
                </a>
                <a class="roundBtn" v-if="status.loginStatus != 0 && status.loginStatus != 5" @click="openBreaksWindow()" v-b-tooltip :title="$t('break_title')">
                    <span class="fa-stack fa-1x">
                    <i class="fa fa-circle fa-stack-2x coffeBG"></i>
                    <i class="fa fa-coffee fa-stack-1x fa-inverse"></i>
                    </span>
                </a>
                <a class="roundBtn " v-if="status.loginStatus == 5"  @click="!doing.unpause && changeAgentStatus('unpause')" v-b-tooltip :title="$t('unBreak_title')">
                    <span class="fa-stack fa-1x">
                    <i v-if="!doing.unpause" class="fa fa-coffee fa-stack-1x" style="color: #fff"></i>
                    <i class="fa fa-ban fa-stack-2x text-danger"></i>
                    <i v-if="doing.unpause" class="fas fa-spinner fa-spin fa-stack-1x fa-inverse"></i>
                    </span>
                </a>
            </div>
            <div class="rowb row2">
                <a class="roundBtn hideOnSmall" v-if="status.status != 0" @click="openNewCallWindow()" v-b-tooltip :title="$t('make_call_title')">
                    <span class="fa-stack fa-1x">
                    <i class="fa fa-circle fa-stack-2x callBG"></i>
                    <i class="fa fa-phone fa-stack-1x fa-inverse"></i>
                    </span>
                </a>
                <a class="roundBtn " v-if="showTransfer" @click="openTransferWindow()" v-b-tooltip :title="$t('transfer_call_title')">
                    <span class="fa-stack fa-1x">
                    <i class="fa fa-circle fa-stack-2x transferBG"></i>
                    <i class="fa fa-exchange fa-stack-1x fa-inverse"></i>
                    </span>
                </a>
                <a class="roundBtn hideOnSmall" v-if="allowSMS" @click="openSMSWindow()" v-b-tooltip :title="$t('sendSMS_title')">
                    <span class="fa-stack fa-1x">
                    <i class="fa fa-circle fa-stack-2x smsBG"></i>
                    <i class="fa fa-envelope fa-stack-1x fa-inverse"></i>
                    </span>
                </a>
                <a class="roundBtn hideOnSmall" v-if="true || allowFax" @click="openFaxWindow()" v-b-tooltip :title="$t('sendFax_title')">
                    <span class="fa-stack fa-1x">
                    <i class="fa fa-circle fa-stack-2x faxBG"></i>
                    <i class="fa fa-fax fa-stack-1x fa-inverse"></i>
                    </span>
                </a>
                <a class="roundBtn hideOnSmall" v-if="allowWebrtc" @click="openWebrtcWindow()" v-b-tooltip :title="$t('open_virtual_phone_title')">
                    <span class="fa-stack fa-1x">
                    <i class="fa fa-circle fa-stack-2x webrtcBG"></i>
                    <i class="fas fa-stack-1x fa-mobile-alt fa-inverse"></i>
                    </span>
                </a>
                <a class="roundBtn hideOnSmall" @click="openReportWindow()" v-b-tooltip :title="$t('report_title')">
                    <span class="fa-stack fa-1x">
                    <i class="fa fa-circle fa-stack-2x reportBG"></i>
                    <i class="fa fa-info fa-stack-1x fa-inverse"></i>
                    </span>
                </a>
                <a class="roundBtn hideOnSmall" v-if="allowSwitchQueues" @click="openSwitchQueuesWindow()" v-b-tooltip :title="$t('switch_queues_title')">
                    <span class="fa-stack fa-1x">
                    <i class="fa fa-circle fa-stack-2x queueBG"></i>
                    <i class="fa fa-tv fa-stack-1x fa-inverse"></i>
                    </span>
                </a>
                <a class="roundBtn hideOnSmall"  @click="switchLanguage()" v-b-tooltip :title="$t('switch_language_title')" >
                    <span class="fa-stack fa-1x">
                    <i class="fa fa-circle fa-stack-2x globeBG"></i>
                    <i class="fa fa-globe fa-stack-1x fa-inverse"></i>
                    </span>
                </a>
            </div>
        </div>

        <div v-show="!displayButtons" class="status">
            <div class="name">{{agentName}} (<i class="fa fa-phone" /> {{extension}})</div>
            <p class="redBG statusShape" v-if="status.status == 0">
                {{ $t('offline_status') }} <i class="fa fa-user-times" />
            </p>
            <p class="greenBG statusShape" v-if="status.status == 1">
                {{ $t('online_status') }} <i class="fa fa-user-o" />
            </p>
            <p class="incomingBG statusShape" v-if="status.status == 2">
				<span v-if="hideNumber">{{$t('talking_status')}}</span>
                <span v-if="!hideNumber">{{$t('talking_with_status')}} <span>{{status.callerId}}</span> <span>{{status.callerName}}</span></span>
				<i class="fa fa-volume-control-phone" />
            </p>
            <p class="outCallBG statusShape" v-if="status.status == 3">
                {{ $t('outgoing_call_status') }} <i class="fa fa-volume-control-phone" />
            </p>
            <p class="yellowBG statusShape" v-if="status.status == 4">
                <span v-if="hideNumber">{{$t('ringing_status')}}</span>
                <span v-if="!hideNumber">{{$t('ringingFrom_status')}} <span>{{status.callerId}}</span> <span>{{status.callerName}}</span></span>
				<i class="fa fa-bell" />
            </p>
            <p class="breakBG statusShape" v-if="status.status == 5">
               {{ $t('break_title') }}  <i class="fa fa-coffee" />
            </p>
            <p class="yellowBG statusShape" v-if="status.status == 6 ">
				<span v-if="hideNumber">{{$t('calling_status')}}</span>
                <span v-if="!hideNumber">{{$t('callingTo_status')}} <span>{{status.callerId}}</span></span>
				<i class="fa fa-bell" />
            </p>
        </div>

        <!-- <span class="switchButtonsBtn fa-stack fa-2x" @click="displayButtons = !displayButtons">
            <i class="fa fa-circle fa-stack-2x loginBG"></i>
            <i v-show="!displayButtons" class="fas fa-ellipsis-h fa-stack-1x fa-inverse"></i>
            <i v-show="displayButtons" class="fas fa-times fa-stack-1x fa-inverse"></i>
        </span> -->

        <toolbar-fax-modal :agent-service="agentService" ref="faxModal" />
        <toolbar-logout-modal :agent-service="agentService" ref="logoutModal" :socket="socket" />
        <toolbar-sms-modal :agent-service="agentService" ref="smsModal" />
        <toolbar-breaks-modal :agent-service="agentService" ref="breaksModal" />
        <toolbar-report-modal :agent-service="agentService" ref="reportModal" />
        <toolbar-new-call-modal :agent-service="agentService" action="new-call" ref="newCallModal" />
        <toolbar-new-call-modal :agent-service="agentService" action="transfer" :call="activeCall" ref="transferCallModal" />
        <toolbar-login-virtual-modal :agent-service="agentService" ref="loginVirtualModal" />
        <toolbar-switch-queues-modal :agent-service="agentService" ref="switchQueuesModal" :extension="extension" />
        <call-toast v-for="(toast, index) in (toasts)" :msg="toast" :agent-service="agentService" :crm-loaded="crmLoaded" v-bind:key="index" />
        <admin-toast v-for="(toast, index) in (adminToasts)" :msg="toast" v-bind:key="index" />
    </div>
</template>

<script>
import {socketBuilder} from "./services/socket";
import {AgentService} from "./services/agent-service";
import toolbarSMSModal from "./components/SMSModal";
import toolbarBreaksModal from "./components/BreaksModal";
import toolbarReportModal from "./components/ReportModal";
import toolbarNewCallModal from "./components/NewCallModal";
import toolbarSwitchQueuesModal from "./components/SwitchQueuesModal";
import toolbarLoginVirtualModal from "./components/LoginVirtualModal";
import toolbarFaxModal from "./components/FaxModal";
import toolbarLogoutModal from "./components/LogoutModal";

// const a = require("../../public/webrtc/HalloWebrtc.common");

import CallToast from "./CallToast";
import AdminToast from "./AdminMessageToast";

export default {
	props: ["enableCrm"],
	data: () => ({
		status: {status: 0, loginStatus: 0},
		doing: {login: false, logoff: false, unpause: false},
		isVirtual: true,
		activeCall: null,
		isOnlyCrm: false,
		receivedEvent: false,
		displayButtons: false,
		extension: null,
		agentName: null,
		agentService: null,
		toasts: [],
		adminToasts: [],
		allowSwitchQueues: false,
		allowSMS: false,
		crmLoaded: false,
		allowFax: false,
		allowWebrtc: false,
		langs: ["he", "en"],
		currentLang: null,
		hideNumber: false,
		url: "",
		isURLOnRinging: false,
		activeCalls: {},
		clearActiveCallsArrayIntervalId: null,
		timings: {
			clearActiveCallsIntervalSeconds: 20,
			maxTimeInActiveCallsSeconds: 60
		},
		socket: null
	}),
	components: {
		toolbarFaxModal, AdminToast, CallToast, "toolbar-sms-modal": toolbarSMSModal, toolbarBreaksModal, toolbarReportModal, toolbarNewCallModal, toolbarSwitchQueuesModal, toolbarLoginVirtualModal, toolbarLogoutModal},
	async created() {
		let config = await window.LSM.systemConfigPromise;
		console.info("received config", config);

		this.agentService = new AgentService(config);
		this.init(config);
		this.agentService.getAgentStatus().then((res) => {
			if (!this.receivedEvent) {
				if (res.callerId && !res.callerName) {
					res.callerName = "";
				}
				console.info("set status to", res);
				this.status = res;
			}
		});

		console.info("VUE", CallToast);

		let LSM = window.LSM;
		LSM.$on("crm:alive", (payload) => {
			this.crmLoaded = payload.val;
			// console.info("Agent Toolbar: CRM LOADED", payload);
		});

		this.clearActiveCallsArrayIntervalId = setInterval(() => {
			this.clearActiveCallsArray();
		}, this.timings.clearActiveCallsIntervalSeconds * 1000);

		// this.$root.$on("bv::modal::shown", (event) => {
		//     event.vueTarget.$refs.modal.classList.add("in");
		// })
		this.switchLanguage(0);
	},
	beforeDestroy() {
		if (this.clearActiveCallsArrayIntervalId) {
			clearInterval(this.clearActiveCallsArrayIntervalId);
			this.clearActiveCallsArrayIntervalId = null;
		}
		// this.$root.$off("bv::modal::shown");
	},
	computed: {
		isAlive() {
			return !([0, 5].includes(this.status.status));
		},
		showTransfer() {
			return this.status.status == 2;
		}
	},
	methods: {
		clearActiveCallsArray() {
			let keys = Object.keys(this.activeCalls);
			let oneMinuteInMilliseconds = 1000 * this.timings.maxTimeInActiveCallsSeconds;
			let minimalForDeletion = Date.now() - oneMinuteInMilliseconds;
			keys.forEach(key => {
				let obj = this.activeCalls[key];
				if (obj.insertTime < minimalForDeletion) {
					delete this.activeCalls[key];
					console.info("should delete this call", obj.insertTime, minimalForDeletion);
				}
			});
		},
		init(config) {
			console.info("agent toolbar init!", config);
			if (!window.io) {
				// maybe change to load from our server in this case?
				console.info("socket.io is missing. trying again in 1 second.");
				if (!this.loadedSocketIO) {
					window.System.import("https://www.unpkg.com/socket.io-client@2.3.0/dist/socket.io.js");
					// window.System.import("socket.io");
					this.loadedSocketIO = true;
				}

				return setTimeout(() => this.init(config), 1000);
			}
			let builder = socketBuilder(config);
			// const
			//     fanvil_test = "1061762407",
			//     fanvil_office = "1078892755",
			//     virtual_test = "1061762408";
			this.agentService.getUserData("me").then(response => {
				// console.info("AGENTTOOLBAR", "Received response for who am i", response);
				this.extension = response.extension;
				this.isVirtual = response.isVirtual;
				this.agentName = response.name;
				this.isOnlyCrm = response.onlyWebsocket;
				this.allowSwitchQueues = response.isQueue;
				this.allowSMS = response.isSMS;
				this.allowWebrtc = response.allowWebrtc;
				this.allowFax = response.isFax;
				this.hideNumber = response.hideNumber;
				this.isURLOnRinging = response.urlOnRing;
				this.popupOnAnswerEvenOnOutbound = "bounceOnIncoming" in response ? response.bounceOnIncoming === 0 : true;
				this.url = response.url;
				this.socket = builder(this.extension);
				console.info("AGENTTOOLBAR", "The builder should work now");
				this.$emit("socketCreated", this.socket);

				this.socket.on("newEvent", (msg) => {
					console.log("SOCKET:", msg);
					this.setStatus(msg);
				});
				this.socket.on("adminMsg", (msg) => {
					console.log("SOCKET:", msg);
					this.showAdminMessage(msg);
				});
				this.socket.on("disconnect", (msg) => {
					console.log("socket disconnected: ", msg);
				});
			});
			// this.extension = virtual_test;
		},
		setStatus(msg) {
			this.receivedEvent = true;
			console.info("Agent Toolbar: received", msg.event);
			switch (msg.event) {
				case "incoming": return this.onIncoming(msg);
				case "outgoing": return this.onOutgoing(msg);
				case "answer": return this.onAnswer(msg);
				case "hangup": return this.onHangup(msg);
				case "login": return this.onLogin(msg);
				case "logoff": case "logout": return this.onLogout(msg);
				case "pause": return this.onPause(msg);
				case "unpause": return this.onUnpause(msg);
				case "directpopup": return this.onDirectPopupMessage(msg);
				default: console.warn("Agent Toolbar: invalid event");
			}
		},
		popUpURL(number) {
			console.info("popup URL");
			let url = null;
			if (this.url.indexOf("%%NUMBER%%") > -1) {
				url = this.url.replace(/%%NUMBER%%/g, number);
			}
			else {
				url = this.url + number;
			}
			this.directPopup(url);
		},
		directPopup(url) {
			let popupWindow = window.open(url, "_blank");
			if (popupWindow) {
				// if the browser blocked the popup, the popupWindow will be null.
				// this is the reason why we must check that we have the window before we trying to do focus
				popupWindow.focus();
			}
			else {
				this.showAdminMessage("Failed to open popup, check popup blocker on your browser");
			}
		},
		onDirectPopupMessage(msg) {
			this.directPopup(msg.event.url);
		},
		onLogin(msg) {
			this.status = {status: 1, callerId: "", callId: "", loginStatus: 1};
			this.activeCall = null;
		},
		onLogout(msg) {
			this.status = {status: 0, callerId: "", callId: "", loginStatus: 0};
			this.activeCall = null;
		},
		onPause(msg) {
			this.status = {status: 5, callerId: "", callId: "", loginStatus: 5};
			this.activeCall = null;
		},
		onUnpause(msg) {
			if (!this.activeCall) {
				this.status = {status: 1, callerId: "", callId: "", loginStatus: 1};
				this.activeCall = null;
			}
			else {
				console.info("received unpause. active call, change only the login status");
				this.status.loginStatus = 1;
			}
		},
		onIncoming(msg) {
			if (!this.isAlive) {
				return;
			}
			if (this.isURLOnRinging && this.url && !msg.is_click_to_call) {
				this.popUpURL(msg.caller_id);
			}
			this.status = {status: 4, callerId: msg.caller_id, callerName: msg.callerName, loginStatus: this.loginStatus};
			if (this.status.callerName === this.status.callerId) {
				this.status.callerName = "";
			}
			this.$emit("call:incoming", msg);
			if (!msg.is_click_to_call) {
				this.showCRMToast(msg);
			}
			// this.activeCall = msg;
			let activeCallObject = Object.assign(msg, {
				outgoing: false,
				_baseUniqueId: msg.uniqueid.replace(/-internal$/g, ""),
				insertTime: Date.now()
			});
			this.activeCall = activeCallObject;
			this.activeCalls[activeCallObject._baseUniqueId] = activeCallObject;
		},
		onOutgoing(msg) {
			if (!this.isAlive) {
				return;
			}
			this.status = {status: 6, callerId: msg.caller_id, loginStatus: this.loginStatus};
			let activeCallObject = Object.assign(msg, {
				outgoing: true,
				_baseUniqueId: msg.uniqueid.replace(/-internal$/g, ""),
				insertTime: Date.now()
			});
			this.activeCall = activeCallObject;
			this.activeCalls[activeCallObject._baseUniqueId] = activeCallObject;
		},
		onAnswer(msg) {
			if (!this.isAlive) {
				return;
			}

			if (this.shouldPopupOnAnswer(msg)) {
				this.popUpURL(msg.caller_id);
			}
			// agnet not offline or in break
			this.status = {
				status: 2,
				callerId: msg.caller_id,
				callerName: msg.callerName,
				callId: msg.callid,
				loginStatus: this.loginStatus
			};
			if (this.status.callerName === this.status.callerId) {
				this.status.callerName = "";
			}
			this.activeCall = Object.assign(this.activeCall, msg);
			// if (msg.hasOwnProperty("campaign") && msg.campaign) {
			//     //$scope.lead = {campaign: msg.campaign, number: msg.caller_id, email: msg.callerName, notes: msg.notes, status: msg.status,  callId: msg.callid};
			//     campaignHandler(msg);
			// } else if ($scope.user.url && $scope.user.urlOnRing == 0 && !$scope.isClickToCall) {
			//     popupUrl($scope.user.url + $scope.status.callerId);
			// } else if ($scope.dialerUrl) {
			//     popupUrl($scope.dialerUrl);
			//     $scope.dialerUrl = "";
			// }
			// if ($scope.dialerCallerName) {
			//     $scope.status.callerName = $scope.dialerCallerName;
			//     $scope.dialerCallerName = "";
			// }
		},
		shouldPopupOnAnswer(msg) {
			/**
			 * the server sends some data only on the incoming call
			 * so we need to check if we have the call in the local history from previews events,
			 * in this case we can get the parameter from there
			 **/

			let shouldPopup = !this.isURLOnRinging && this.url;
			if (!shouldPopup) {
				return false;
			}
			let callFromLocalHistory = this.activeCalls[msg.uniqueid];
			if (!callFromLocalHistory) {
				return true; // this was the previous behavior
			}
			let isClickToCall = callFromLocalHistory.is_click_to_call;
			let isOutgoingCall = callFromLocalHistory.outgoing;
			if (isClickToCall) {
				return false;
			}
			if (this.popupOnAnswerEvenOnOutbound) {
				return true;
			}

			return !isOutgoingCall;
		},
		onHangup(msg) {
			this.activeCall = null;
			let status = null;
			if (this.status.status === 0) {
				status = 0;
			}
			else if (this.status.status === 5) {
				status = 5;
			}
			else {
				status = 1;
			}
			// console.info("status before hangup", this.status);
			this.status = {status: status, callerId: "", callId: "", loginStatus: this.status.loginStatus};
			if (this.activeCalls[msg.uniqueId]) {
				delete this.activeCalls[msg.uniqueId];
				console.info("deleted call from active calls array");
			}
			// console.info("status after hangup", this.status);
		},
		virtualLogout() {
			let newStatus = "logoff";
			this.doing[newStatus] = true;
			return this.agentService.virtualLogout()
				.then(result => {
					this.doing[newStatus] = false;
				})
				.catch(() => {
					this.doing[newStatus] = false;
				});
		},
		changeAgentStatus(newStatus, direct = false) {
			// status : 0 - Unavailable, 1 - Idle, 2 - Incoming Call , 3 - Outgoing Call,  4- Ringing, 5 - break, 6 -Calling
			// if (!validStatus($scope.status.status, changeTostatus)) {
			// 	return;
			// }

			if (this.isVirtual) {
				switch (newStatus) {
					case "login": return this.openLoginVirtualWindow();
					case "logoff": {
						this.virtualLogout();
						return this.askUserForLogout();
					}
				}
			}

			this.doing[newStatus] = true;
			this.agentService
				.changeAgentStatus({status: newStatus})
				.then(res => {
					this.doing[newStatus] = false;
					if (res === "ok") {
						// this.setStatus({ event: newStatus });
						// toaster.pop("success", changeTostatus + " successfully");
					}
					else {
						// toaster.pop("error", "Unexpected error. please try again.");
					}
					if (newStatus === "logout") {
						this.askUserForLogout();
					}
				});
		},
		askUserForLogout() {
			this.$refs.logoutModal.open();
		},
		openBreaksWindow() {
			this.$refs.breaksModal.open();
		},
		openSMSWindow() {
			this.$refs.smsModal.open();
		},
		openNewCallWindow() {
			this.$refs.newCallModal.open();
		},
		openTransferWindow() {
			this.$refs.transferCallModal.open();
		},
		openReportWindow() {
			this.$refs.reportModal.open();
		},
		openSwitchQueuesWindow() {
			this.$refs.switchQueuesModal.open();
		},
		openLoginVirtualWindow() {
			this.$refs.loginVirtualModal.open();
		},
		openFaxWindow() {
			this.$refs.faxModal.open();
		},
		async showCRMToast(msg) {
			if (!this.enableCrm) {
				return;
			}
			let activeToast = this.toasts.find(toast => toast.callid == msg.callid);
			// console.info(activeToast ? "found" : "not found", activeToast);
			if (!activeToast) {
				this.toasts.push({...msg, showToast: true});
			}
		},
		showAdminMessage(msg) {
			this.adminToasts.push(msg);
		},
		openWebrtcWindow() {
			let popupInstance = window.open("about:blank", "webrtc");
			this.agentService.getWebrtcPopupLink()
				.then(link => {
					popupInstance.location.href = link;
					this.webrtcWindow = popupInstance;
				})
				.catch(() => {
					popupInstance.close();
					popupInstance = null;
				});
		},
		switchLanguage(index) {
			let newLangIndex = index;
			if (index === undefined) {
				newLangIndex = this.langs.indexOf(this.currentLang) + 1;
				if (newLangIndex >= this.langs.length) {
					newLangIndex = 0;
				}
			}
			this.currentLang = this.langs[newLangIndex];
			this.$i18n.locale = this.currentLang;
		}
	}
};
</script>

<style lang="scss" scoped>
.agentToolbarParent{
    text-align: right; display: flex;
    // flex-direction: column-reverse;
}
.LangHE .agentToolbarParent {
    text-align: left;
}
.name {color: white; margin-inline-end: 5px;padding-bottom: 2px;}

.statusShape {
    font-size: 16px; color: #222; text-align: center;
    font-weight: 700;
    min-width: 240px; padding: 4px; padding-bottom: 0;
    margin-bottom: 4px;
}

.LangEN .statusShape{
    border-radius: 20px 0 0 20px;
}

.LangHE .statusShape{
    border-radius: 0 20px 20px 0;
}

.buttons {
    > .roundBtn {
        flex: 1;
    }
    .roundBtn:hover {
         cursor: pointer;
    }
    // min-width: 10em;
    display: flex;
    .rowb {display: flex; flex-direction: row-reverse;}
	margin-top: auto;
}

@mixin mode_hide {
    .agentToolbarParent { display: none; }
}
@mixin mode_mini {
    .agentToolbarParent .buttons {
        font-size:18px; flex-direction: column;
        &.row1{margin-bottom: 2px;}
    }
}
@mixin mode_full {
    .agentToolbarParent .buttons {
        font-size:30px; flex-direction: row-reverse;
    }
}

.yellowBG {background-color:#fed136!important}
.greenBG {background-color:#88e964!important}
.redBG {background-color:#f66666!important}
.breakBG {background-color:#bcaaa4!important}
.incomingBG,
.outCallBG {background-color:#00bcd4!important}

.loginBG {color:#72c04e}
.logoutBG {color:#f66666}
.coffeBG {color:#bcaaa4}
.callBG {color:#00bcd4}
.transferBG {color:#ff8a65}
.smsBG {color:#a483d1}
.webrtcBG {color:#8fccff;}
.reportBG {color:#4c77ff}
.queueBG {color:#00796b}
.globeBG {color:#ff8a65}

.faxBG {color:#eba550}

.fa-spinner {cursor: wait;}
.switchButtonsBtn {
    // position: relative;
    // margin-inline-end: -30px;
    cursor: pointer;
}

$bp_1btn: 890px;
$bp_2btn: 1004px;
$bp_3btn: 1118px;
$bp_4btn: 1232px;
$bp_full: 280px;

@media screen and (max-width: 550px) {
	.hideOnSmall {
		display: none;
	}
}

 @media screen and (max-width: calc(#{$bp_1btn} + 1px)) {
	.statusShape {
			min-width: 180px;
		}
 }
.btns0  {
	// @include mode_full; color: #62462400;
    // @media screen and (max-width: $bp_2btn) { @include mode_hide; }
    @media screen and (min-width: calc(#{$bp_2btn} + 1px)) { @include mode_mini; }
    @media screen and (min-width: calc(#{$bp_1btn} )) { @include mode_full; }
}
.btns1  {
    @media screen and (max-width: $bp_1btn) { @include mode_hide; }
    @media screen and (min-width: calc(#{$bp_1btn} + 1px)) and (max-width: calc(#{$bp_1btn} + #{$bp_full})) { @include mode_mini; }
    @media screen and (min-width: calc(#{$bp_1btn} + #{$bp_full} + 1px)) { @include mode_full; color: #62462400; }
}
.btns2 {
    @media screen and (max-width: $bp_2btn) { @include mode_hide; }
    @media screen and (min-width: calc(#{$bp_2btn} + 1px)) and (max-width: calc(#{$bp_2btn} + #{$bp_full})) { @include mode_mini; }
    @media screen and (min-width: calc(#{$bp_2btn} + #{$bp_full} + 1px)) { @include mode_full; }}
.btns3 {
    @media screen and (max-width: $bp_3btn) { @include mode_hide; }
    @media screen and (min-width: calc(#{$bp_3btn} + 1px)) and (max-width: calc(#{$bp_3btn} + #{$bp_full})) { @include mode_mini; }
    @media screen and (min-width: calc(#{$bp_3btn} + #{$bp_full} + 1px)) { @include mode_full; }}
.btns4 {
    @media screen and (max-width: $bp_4btn) { @include mode_hide; }
    @media screen and (min-width: calc(#{$bp_4btn} + 1px)) and (max-width: calc(#{$bp_4btn} + #{$bp_full})) { @include mode_mini; }
    @media screen and (min-width: calc(#{$bp_4btn} + #{$bp_full} + 1px)) { @include mode_full; }}

.b-tooltip {
    z-index:9001;
    font-size: 1em;
}
</style>
